{
    "api": {
        "title": "مرجع واجهات البرمجة",
        "subtitle": "يُولَّد من التطبيق العامل في كل مرة تُفتح فيها هذه الصفحة — من جدول المسارات وكائنات الطلب وتوثيق المتحكمات نفسها. فلا يصف نقطة نهاية لم تعد موجودة، ولا يغفل نقطة أُضيفت هذا الصباح.",
        "generated": "قُرئ من التطبيق في {{time}}",
        "count": "{{count}} نقطة نهاية",
        "search": "ابحث في نقاط النهاية",
        "search_placeholder": "المسار أو الاسم أو الوصف",
        "no_results": "لا تطابق أي نقطة نهاية ذلك.",
        "summary": "الوصف",
        "authentication": "المصادقة",
        "authenticated": "جلسة مسجّلة أو مفتاح واجهة",
        "public": "عامة — لا تتطلب جلسة",
        "authorisation": "الصلاحية",
        "auth_mode": {
            "request": "يعلنها كائن الطلب",
            "middleware": "تفرضها وسيطة المسار",
            "controller": "تُفحص في المتحكم",
            "authenticated_only": "تكفي المصادقة",
            "undetermined": "غير قابلة للتحديد من الشيفرة"
        },
        "rate_limit": "حد المعدل",
        "path_parameters": "معاملات المسار",
        "parameters": "معاملات الجسم",
        "no_parameters": "لا تأخذ نقطة النهاية هذه معاملات في الجسم.",
        "parameters_unknown": "تعذّرت قراءة قواعد التحقق خارج طلب حقيقي ({{note}}). راجع كائن الطلب بدل افتراض عدم وجودها.",
        "field": "الحقل",
        "rules": "القواعد",
        "requirements": "المتطلبات",
        "expand": "أظهر التفاصيل",
        "collapse": "أخفِ التفاصيل",
        "openapi": "مواصفة OpenAPI 3.1"
    }
}
